import { render } from "./ForgottenPassword.vue?vue&type=template&id=385d6bc4"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js"

import "./ForgottenPassword.vue?vue&type=style&index=0&id=385d6bc4&lang=css"
script.render = render

export default script